// The locale the active translator was made for, for Intl formatters, so dates
// and numbers follow the site's language instead of the browser's. i18n/index
// sets it whenever it makes or activates a translator: in the browser from
// window.__locale_data, in the ssr service per render. Server and client then
// format with the same locale, so hydration matches. Kept apart from
// i18n/index so tests that mock that module still get the real value.
const DEFAULT_LOCALE = 'en';

let current = DEFAULT_LOCALE;

export const setActiveLocale = (locale) => {
	current = locale || DEFAULT_LOCALE;
};

export const activeLocale = () => current;

// Intl.DateTimeFormat in the active locale. Takes a Date, a moment or a
// millisecond timestamp.
export const formatDate = (date, options) => {
	const instant = date && typeof date.toDate === 'function' ? date.toDate() : date;
	return new Intl.DateTimeFormat(current, options).format(instant);
};

// Intl.NumberFormat in the active locale.
export const formatNumber = (value, options) => new Intl.NumberFormat(current, options).format(value);
